<app-planting-sites-shell
                        [backendCall]="true"
                        (plantingSitesChange)="sites = $event"
                        [unfilteredSites]="unfilteredSites"
                        [unfilteredSitesChanged$]="unfilteredSitesChanged$"
                        [pageSize]="pageSize"
                        (onUpdatePageSize)="updatePageSize($event)"
                        [showAddNew]="true">
    <app-site-table *ngIf="sites" 
        [sites]="sites" 
        [pageSizeUpdate$]="pageSizeUpdate$"
        (siteDeleted)="siteDeleted($event)"
        [pageSize]="pageSize">
    </app-site-table>
</app-planting-sites-shell>
